import React, { useEffect, useState } from 'react';

const Weather = () => {
  const [weatherState, setWeatherState] = useState("wi-day-sunny");
  const [uInVal, setuInVal] = useState("kanepokhari");
  const [tempInfo, setTempInfo] = useState("");
  let sec = tempInfo.sunset;
  let date = new Date(sec * 1000);
  let timeStr = `${date.getHours()}:${date.getMinutes()}`;

  useEffect(() => {
    switch (tempInfo.cloudMood) {
      case "Clouds":
        setWeatherState("wi-day-cloudy");
        break;
      case "Haze":
        setWeatherState("wi-fog");
        break;
      case "Clear":
        setWeatherState("wi-day-sunny");
        break;
      default:
        setWeatherState("wi-day-sunny");
        break;
    }
  }, [tempInfo.cloudMood]);

  const getData = async () => {
    try {
      const url = `https://api.openweathermap.org/data/2.5/weather?q=${uInVal}&units=metric&appid=7deb5d5ef513acbd22dfbbe0bbc92e65`;
      const res = await fetch(url);
      const mainData = await res.json();
      const { temp, humidity, pressure } = mainData.main;
      const { main: cloudMood } = mainData.weather[0];
      const { name } = mainData;
      const { speed } = mainData.wind;
      const { country, sunset } = mainData.sys;
      const myNewWeatherInfo = {
        temp,
        humidity,
        pressure,
        name,
        cloudMood,
        speed,
        country,
        sunset
      };
      setTempInfo(myNewWeatherInfo);
    } catch (error) {
      alert(error);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  const handleSearch = () => {
    getData();
  };

  return (
    <>
      <style>
        {`
         @import url(https://fonts.googleapis.com/css?family=Poiret+One);
         @import url(https://cdnjs.cloudflare.com/ajax/libs/weather-icons/2.0.9/css/weather-icons.min.css);
 
         * {
           margin: 0;
           padding: 0;
           box-sizing: border-box;
         }
         
         body {
           font-family: 'Poiret One', cursive;
           background-color: #f5f5f5;
           color: #2f2f2f;
           margin: 0;
         }
         
         .container {
           display: flex;
           flex-direction: column;
           align-items: center;
           justify-content: center;
           height: 100vh;
           padding: 0 20px;
         }
         
         .search {
           margin-bottom: 20px;
           display: flex;
           width: 100%;
         }
         
         .searchTerm {
           width: 70%;
           border: none;
           border-radius: 5px 0 0 5px;
           padding: 10px;
           outline: none;
           font-size: 16px;
         }
         
         .searchTerm:focus {
           color: #00b4cc;
         }
         
         .searchButton {
           width: 30%;
           border: none;
           background-color: #048b9c;
           color: #fff;
           border-radius: 0 5px 5px 0;
           cursor: pointer;
           font-size: 16px;
           outline: none;
         }
         
         .searchButton:hover {
           background-color: #17b8ce;
         }
         
         .weatherCard {
           width: 100%;
           max-width: 400px;
           background-color: #fff;
           border-radius: 10px;
           box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
           padding: 20px;
           text-align: center;
         }
         
         .weatherIcon {
           font-size: 100px;
           margin-bottom: 20px;
         }
         
         .temperature {
           font-size: 36px;
           font-weight: bold;
         }
         
         .weatherCondition {
           font-size: 24px;
           margin-bottom: 10px;
         }
         
         .place {
           font-size: 18px;
           margin-bottom: 20px;
         }

         .extraInfo {
           display: flex;
           justify-content: space-between;
           font-size: 16px;
         }
        `}
      </style>

      <div className="container">
        <div className="search">
          <input 
            type="text"
            placeholder="Enter city name..."
            className="searchTerm"
            value={uInVal}
            onChange={(e) => setuInVal(e.target.value)}
          />
          <button 
            className="searchButton"
            onClick={handleSearch}
          >
            Search
          </button>
        </div>

        {tempInfo && (
          <div className="weatherCard">
            <div className="weatherIcon">
              <i className={`wi ${weatherState}`}></i>
            </div>
            <div className="temperature">{tempInfo.temp}°C</div>
            <div className="weatherCondition">{tempInfo.cloudMood}</div>
            <div className="place">
              {tempInfo.name}, {tempInfo.country}
            </div>
            <div className="extraInfo">
              <div>Humidity: {tempInfo.humidity}%</div>
              <div>Pressure: {tempInfo.pressure} hPa</div>
              <div>Wind Speed: {tempInfo.speed} m/s</div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Weather;
